import {
  PlusCircle,
  MessageCircle,
  Users,
  LogOut,
  LayoutDashboard,
  UserCircle,
  BookOpen,
  Home,
  CreditCard,
  ReceiptText,
  User,
} from 'lucide-react';
import type { ReactNodeCompat } from '@/types/react-compat';

export type Role = 'patient' | 'therapist';

export type NavItem = {
  key: string;
  label: string;
  href: string;
  method?: 'get' | 'post' | 'put' | 'patch' | 'delete';
  external?: boolean;
  icon?: (props: { className?: string }) => ReactNodeCompat;
  permissions?: string[];
  matchPattern?: string | string[];
};

export type MenuSection = {
  name: string;
  pullDown?: boolean;
  items: NavItem[];
};

export function useNavItems(role: Role) {
  const therapistNav: MenuSection[] = [
    {
      name: 'Menu',
      items: [
        {
          key: 'dashboard',
          label: 'Dashboard',
          href: '/therapists/dashboard',
          icon: LayoutDashboard,
        },
        { key: 'patients', label: 'Clienti', href: '/therapists/patients', icon: Users },
        {
          key: 'tone_session',
          label: 'Tone of voice',
          href: '/therapists/tone_session',
          icon: UserCircle,
        },
      ],
    },
    {
      name: 'Abbonamento',
      items: [
        {
          key: 'subscription',
          label: 'Gestisci abbonamento',
          href: '/therapists/subscription',
          icon: CreditCard,
        },
        {
          key: 'billing',
          label: 'Fatturazione',
          href: '/therapists/billing',
          icon: ReceiptText,
        },
      ],
    },
    {
      name: 'Account',
      pullDown: true,
      items: [
        {
          key: 'account',
          label: 'Account',
          href: '/therapists/edit',
          icon: User,
        },
        {
          key: 'logout',
          label: 'Esci',
          href: '/therapists/sign_out',
          method: 'delete',
          icon: LogOut,
        },
      ],
    },
  ];

  const patientNav: MenuSection[] = [
    {
      name: 'Menu',
      items: [
        { key: 'dashboard', label: 'Home', href: '/patients/dashboard', icon: Home },
        {
          key: 'new_chat',
          label: 'Nuova chat',
          href: '/patients/chats/new',
          method: 'get',
          icon: PlusCircle,
        },
        { key: 'chats', label: 'Le mie chat', href: '/patients/chats', icon: MessageCircle },
        { key: 'journals', label: 'Il mio diario', href: '/patients/journals', icon: BookOpen },
      ],
    },
    {
      name: 'Account',
      pullDown: true,
      items: [
        // { key: 'profile', label: 'Profilo', href: '/patients/profile', icon: UserCircle },
        {
          key: 'logout',
          label: 'Esci',
          href: '/patients/sign_out',
          method: 'delete',
          icon: LogOut,
        },
      ],
    },
  ];

  return { menuSections: role === 'therapist' ? therapistNav : patientNav, account: [] };
}
